import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ReplyComposer({ task, onSent }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const realChat = task?.chat_id && String(task.chat_id).includes("@");

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post("/whatsapp/send", {
        chat_id: task.chat_id,
        text: text.trim(),
        task_id: task.id,
      });
      toast.success("Sent on WhatsApp");
      setText("");
      onSent?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Send failed");
    } finally { setSending(false); }
  };

  return (
    <div className="border border-slate-200 rounded-sm bg-slate-50/50" data-testid="reply-composer">
      <div className="px-4 py-2.5 border-b border-slate-200 flex items-center justify-between">
        <div className="label-eyebrow flex items-center gap-1.5">
          <Send size={11} /> Send a reply on WhatsApp
        </div>
        {!realChat && (
          <span className="text-[10.5px] tracking-[0.16em] uppercase font-bold text-slate-500 bg-white px-1.5 py-0.5 border border-slate-200 rounded-sm">
            Unavailable
          </span>
        )}
      </div>
      <div className="p-4 space-y-3">
        {!realChat ? (
          <p className="text-[13px] text-slate-600">
            This task came from the manual simulator. Replies are only sent for chats received via the live WhatsApp bridge.
          </p>
        ) : (
          <>
            <textarea
              rows={4}
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Type your reply…"
              className="w-full p-3 border border-slate-200 rounded-sm bg-white text-[14px] focus:border-slate-900 outline-none resize-y"
              data-testid="reply-text-input"
            />
            <div className="flex items-center justify-between">
              <span className="text-[11px] text-slate-400 font-mono truncate max-w-[60%]">
                → {task.chat_id}
              </span>
              <button
                onClick={send}
                disabled={sending || !text.trim()}
                className="h-9 px-4 inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-800 text-white rounded-sm text-[13px] disabled:opacity-60"
                data-testid="reply-send-btn"
                type="button"
              >
                {sending ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />}
                {sending ? "Sending…" : "Send WhatsApp reply"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
